import { post, get } from 'aws-amplify/api';

export const validateCssFile = (file) => {
  if (!file) {
    throw new Error('No file provided');
  }
  if (!file.type.includes('text/css')) {
    throw new Error('File must be a CSS file');
  }
  if (file.size > 1024 * 1024) { // 1MB limit
    throw new Error('CSS file size must be less than 1MB');
  }
};

export const uploadCssFile = async (file) => {
  try {
    const urlResponse = await post({
      apiName: 'events',
      path: '/upload-url',
      options: {
        body: JSON.stringify({
          fileType: file.type,
          fileName: file.name
        })
      }
    }).response;
    
    const { uploadUrl, key } = await urlResponse.json();
    await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    });
    
    return key;
  } catch (error) {
    console.error('Error uploading CSS file:', error);
    throw new Error('Failed to upload CSS file');
  }
};

export const uploadImage = async (file) => {
  try {
    const urlResponse = await post({
      apiName: 'events',
      path: '/upload-url',
      options: {
        body: JSON.stringify({
          fileType: file.type,
          fileName: file.name
        })
      }
    }).response;
    
    const { uploadUrl, key } = await urlResponse.json();
    await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    });
    
    return key;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw new Error('Failed to upload image');
  }
};

export const fetchCustomCss = async (cssKey) => {
  if (!cssKey) return null;
  try {
    const response = await get({
      apiName: 'invitation',
      path: `/assets/${cssKey}`,
    }).response;
    
    return await response.text();
  } catch (error) {
    console.error('Error fetching custom CSS:', error);
    return null;
  }
};